import type { VFXNodeDefinition } from '../../types';
/**
 * @engine/vfx — update-context node pack (sliced by category).
 */
import { FORCE_NODES } from './forces';
import { OVER_LIFE_NODES } from './overLife';
import { SETTER_NODES } from './setters';
import { KILL_COLLISION_NODES } from './killCollision';
import { MISC_UPDATE_NODES } from './misc';

export const UPDATE_NODES: readonly VFXNodeDefinition[] = [
  ...FORCE_NODES,
  ...OVER_LIFE_NODES,
  ...SETTER_NODES,
  ...KILL_COLLISION_NODES,
  ...MISC_UPDATE_NODES,
];
